import React from 'react';
import { Grid } from '@mui/material';
import { useWatch } from 'react-hook-form';
import {
  NumberField,
  ReferenceArrayField,
  ReferenceField,
  SelectField,
  SingleFieldList,
} from 'react-admin';

import Label from '../../../customFields/Label';
import { unitsOfTimeChoices } from '../../../constants/unitsOfTime';
import dueDiligenceDatesToTrack, { dueDiligenceDateToTrackChoices } from '../../../constants/dueDiligenceDatesToTrack';
import ChipStringField from '../../../customFields/ChipStringField';
import resourceNames from '../../../constants/resourceNames';

const DueDiligence = () => {
  const {
    ruleParameters: {
      dateToTrack,
    },
  } = useWatch();

  return (
    <Grid size={12}>
      <Grid container spacing={1}>
        <Grid size={12}>
          <Label
            variant="label"
            title="Date to track"
          />
        </Grid>
        <Grid size={12}>
          <SelectField
            choices={dueDiligenceDateToTrackChoices}
            source="ruleParameters.dateToTrack"
          />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Label
            variant="label"
            title="Default threshold"
          />
          <NumberField source="ruleParameters.defaultThreshold" />
        </Grid>

        <Grid
          size={{
            xs: 12,
            md: 6,
          }}
        >
          <Label
            variant="label"
            title="Unit of time"
          />
          <SelectField
            choices={unitsOfTimeChoices}
            source="ruleParameters.unitOfTime"
          />
        </Grid>

        {dateToTrack === dueDiligenceDatesToTrack.LAST_FORM_SUBMITTED_DATE
          && (
            <>
              <Grid size={12}>
                <Label
                  variant="label"
                  title="Forms to consider"
                />
              </Grid>

              <Grid size={12}>
                <ReferenceArrayField source="ruleParameters.formIds" reference="forms">
                  <SingleFieldList linkType={false}>
                    <ChipStringField source="title" />
                  </SingleFieldList>
                </ReferenceArrayField>
              </Grid>
            </>
          )}

        {dateToTrack === dueDiligenceDatesToTrack.GROUP_ASSIGNMENT
          && (
            <>
              <Grid size={12}>
                <Label
                  variant="label"
                  title="Group to consider"
                />
              </Grid>

              <Grid size={12}>
                <ReferenceField source="ruleParameters.groupToTrack" reference={resourceNames.GROUPS} />
              </Grid>
            </>
          )}
      </Grid>
    </Grid>
  );
};

export default DueDiligence;
